import * as React from "react";

// Here is the way to create generic Component
// https://github.com/Microsoft/TypeScript/issues/3960#issuecomment-165330151
type SelectProps = {
    items: any[];
    valueFn?: (item: any, idx?: number) => string; // the value for <select /> has to be string
    titleFn?: (item: any, idx?: number) => string;
    
    defaultValue?: string;
    placeholder?: string;

    onChange?: (select: Select) => void;
    className?: string;
    disabled?: boolean;
}

type SelectState = {
    value: string;
}

// Select component is a wrapper around native select
// It accepts getters to query value and display of underlying data
// Also it helps to show placeholder whcih cannot be selected from the list
export class Select extends React.Component<SelectProps, SelectState>
{
    constructor(props: SelectProps)
    {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(nextProps: Readonly<SelectProps>, nextContext: any)
    {
        const nextState = this.getStateFromProps(nextProps);
        // if(this.state.value !== nextState.value) {
        //     const { onChange } = nextProps;
        //     onChange(this);
        // }
        this.setState(nextState);
    }

    private getStateFromProps(props: Readonly<SelectProps>)
    {
        let initialValue = props.defaultValue;

        // reset the value if it is not in item source
        if(initialValue != null) {
            const valueFn = this.getValueFn(props.valueFn);
            const found = props.items.find((item, idx) => valueFn(item, idx) == initialValue);
            initialValue = (found === undefined) ? null : initialValue;
        }
        
        if(initialValue == null) {
            if(props.placeholder == null)
                throw 'Provide placeholder if defaultValue is not in itemSource';
            
            initialValue = '';
        }

        return {
            value: initialValue
        };
    }

    render ()
    {
        const valueFn = this.getValueFn(this.props.valueFn);
        const titleFn = this.getTitleFn(this.props.titleFn);
        const placeholder = this.props.placeholder;

        return (
            <select value={this.state.value} onChange={this.onChange.bind(this)} className={this.props.className} disabled={this.props.disabled}>
                {
                    // https://stackoverflow.com/questions/5805059/how-do-i-make-a-placeholder-for-a-select-box/8442831#8442831
                    (placeholder != null) && <option value={''} disabled hidden>{placeholder}</option>
                }
                {
                    this.props.items.map((item, idx) => <option key={idx} value={valueFn(item, idx)}>{titleFn(item, idx)}</option>)
                }
            </select>
        );
    }

    private getValueFn (valueFn: (item: any, idx: number) => string)
    {
        return (item: any, idx: number) => {
            const value = valueFn ? valueFn(item, idx) : idx.toString();
            if(value == null)
                throw 'valueFn has to return a string';
            return value;
        };
    }

    private getTitleFn (titleFn: (item: any, idx: number) => string)
    {
        return (item: any, idx: number) => {
            return titleFn ? titleFn(item, idx) : JSON.stringify(item);
        };
    }

    private onChange (e: React.ChangeEvent<HTMLSelectElement>)
    {
        this.setState({
            value: e.target.value
        }, () => {
            if(this.props.onChange)
                this.props.onChange(this);
        });
    }

    getValue ()
    {
        const { value } = this.state;
        return (value == '') ? null : value;
    }
}


// WEBPACK FOOTER //
// ./src/components/Select.tsx